import API from "Services/Api";
import { DependentData } from "./types";



export const getDependents = async (person_id: number) => {
  try {

    const data = await API.get(`/persons/${person_id}/dependents`);

    return data.data
  } catch (error) {
    console.error(error)
  }
}

export const createDependent = async (dependentData: DependentData, responsible_id: number) => {
  try {
    const response = await API.post(`/persons/${responsible_id}/dependents`, {
      ...dependentData
    });

    return response.data
  } catch (err) {
    console.error(err)
    throw "Ops! Ocorreu um erro ao criar a dependente";
  }
}

export const updateDependent = async (dependentData: DependentData, responsible_id: number, dependent_id: number) => {
  try {
    const response = await API.put(`/persons/${responsible_id}/dependents/${dependent_id}`, {
      ...dependentData
    });
    return response.data
  } catch (err) {
    console.error(err)
    throw "Ops! Ocorreu um erro ao atualizar o dependente";
  }
}